








































import {
  Component, Prop, Vue,
  Watch,
} from 'vue-property-decorator';
import { VbSnackbarService } from 'bag-of-holding-library';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import PersistSkill from '@/domain/drd-2.0/entity/persist-skill.entity'
import SkillService from '@/domain/drd-2.0/service/skill.service';
import Skill from '@/domain/drd-2.0/entity/skill.entity';
import FormSkillComponent from '../form/form-skill.component.vue'

@Component({
  components: {
    LabelSlot,
    FormSkillComponent,
  },
})
export default class UpdateSkillModal extends Vue {
  @Prop({
    type: Boolean,
    default: false,
  }) open!: boolean;

  @Prop({
    required: true,
  }) initialValue!: Skill;

  @Prop({
    type: String,
    required: true,
  }) skillId!: string;

  loading: boolean = false;

  skill: PersistSkill = new PersistSkill();

  @Watch('initialValue', { immediate: true })
  onInitialValueChange(value: PersistSkill) {
    this.skill = new PersistSkill(
      { ...value },
    );
  }

  closeModal() {
    this.skill = new PersistSkill();
    this.$emit('close');
  }

  saved(skill: Skill) {
    this.$emit('saved', skill);
  }

  save() {
    const { formComponent } = this.$refs as any;
    const { form } = formComponent.$refs;
    if (!form.validate()) return;
    this.loading = true;
    SkillService.update(this.skill, this.skillId)
      .then(({ data }: any) => {
        VbSnackbarService.showSuccess('Competência atualizada com sucesso!')
        this.saved(data);
      })
      .catch((error) => {
        VbSnackbarService.showError(error.response.data.messages.toString());
      })
      .finally(() => this.loading = false);
  }

  update(event: any) {
    this.skill[event.field] = event.value;
  }
}
